
import './Customers.scss';

import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { FaLongArrowAltRight,FaLongArrowAltLeft} from "react-icons/fa";
import {images, Desc} from './data';

function Customer() {

    const [selectedTab, setSelectedTab] = useState(0);
    const tabCount = 7;

  return (
    <div className="customers-testimonial">
        <div className="content">

        <h1>Everybody loves working with us</h1>
        <p className='slider-p'>Here's what are customers have to say about us.</p>
        </div>
        <Tabs className='slider-tab-row' selectedIndex={selectedTab} onSelect={index => setSelectedTab(index)}>
            <TabList>
                {images.map((props) => {
                    return(
                        <Tab tabFor={props.id}>
                           <img id={props.id} src={props.img}/>
                           
                        </Tab>
                    )
                })}
            </TabList>

                <div className="panels">
                    {Desc.map((props) => {
                        return(
                            <TabPanel className="panel" tabIndex={props.id}>
                                <p>{props.comment}</p>
                                <div className='block'>
                                    <div className='line'></div>
                                    <small>{props.name}</small>
                                    <span> - Read case study</span>
                                </div>
                            </TabPanel>
                        )
                    })}
                    <button onClick={() => setSelectedTab((selectedTab + tabCount - 1) % tabCount )}><FaLongArrowAltLeft /></button>
                    <button onClick={() => setSelectedTab((selectedTab + 1) % tabCount )}><FaLongArrowAltRight /></button>
                </div>
                
        </Tabs>


    </div>
  );
}

export default Customer;